import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const GuestOnlyRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking auth status
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // If user is authenticated, redirect to dashboard or intended destination
  if (user) {
    // Check if there's a return destination in the location state
    const returnTo = location?.state?.returnTo || '/market-trend-alerts-dashboard';
    
    // Redirect with success message
    return (
      <Navigate 
        to={returnTo} 
        state={{ 
          message: 'You are already signed in!',
          fromAuth: true 
        }} 
        replace 
      />
    );
  }

  // If user is not authenticated, render the auth page
  return children;
};

export default GuestOnlyRoute;